import * as yup from 'yup';

export const AddMobileApplicationSchema = yup.object().shape({
  buildName: yup.string().required('Build Name is required'),
  buildNumber: yup.string().required('Build Number is required'),
  // variant: yup.string().required('Variant is required'),
  changelogs: yup.string().required('Change Logs is required'),
});
